/**
 * Query params for the product detail endpoint
 * (GET /ms/migraciones/v1.0/items).
 *
 * The previous code interpolated both values into the URL:
 *   `/ms/migraciones/v1.0/items?id=${payload.id}&idSede=${payload.idSede}`
 * so a caller without a resolved id or sede sent the *literal* string
 * "undefined" (`?id=undefined&idSede=undefined`). That request never had a
 * chance: the backend rejects it and the UI showed a generic error.
 *
 * This helper keeps the decision out of the component so it can be verified
 * without a browser: it returns the normalized params, or null when the
 * request must not be fired at all.
 *
 * Kept free of imports on purpose.
 */

/** Accepts 21023, "21023" and rejects 0, -1, "abc", "undefined", null, ''. */
export const toPositiveInt = (value) => {
    if (value === undefined || value === null) return null
    if (typeof value === 'boolean') return null
    const text = String(value).trim()
    if (text === '' || ['undefined', 'null', 'NaN'].includes(text)) return null
    const parsed = Number(text)
    if (!Number.isInteger(parsed) || parsed <= 0) return null
    return parsed
}

/**
 * @param {{ id?: any, idSede?: any }} payload component payload
 * @param {any} sessionSede fallback taken from the logged user (users.user.idSede)
 * @returns {{ id: number, idSede: number } | null} null when the request is not possible
 */
export const buildObtenerProductoParams = (payload = {}, sessionSede = null) => {
    const source = payload || {}
    const id = toPositiveInt(source.id)
    const idSede = toPositiveInt(source.idSede) ?? toPositiveInt(sessionSede)
    if (!id || !idSede) return null
    return { id, idSede }
}
